<template>
    <v-dialog max-width="500" v-model="show" :fullscreen="$vuetify.breakpoint.mobile">
        <v-card>
            <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                {{$translate('Change image for')}} {{user.name.split(' ')[0]}}
                <v-spacer />
                <v-btn icon @click="show = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <v-btn @click="$refs.iuploader.click()" color="primary" block class="mt-2" :outlined="!!image.src">
                    <input ref="iuploader" class="d-none" type="file" accept="image/*" @change="fileSelected">
                    {{$translate(image.src ? 'Choose a different image' : 'Choose image')}}
                </v-btn>
            </v-card-text>

            <user-avatar :size="120" :user="user" v-if="!image.src" />

            <preview v-else style="border-radius: 50%; margin: auto; margin-bottom: 8px"
                     :width="120"
                     :height="120"
                     :image="result.image"
                     :coordinates="result.coordinates" />

            <cropper
                ref="cropper"
                :src="image.src"
                @change="change"
                :auto-zoom="true"
                :stencil-size="{
                    width: 280,
                    height: 280
                }"
                image-restriction="stencil"
            />
            <v-card-actions>
                <v-btn class="zoezi-button-thin" block @click="save" :loading="saving" :disabled="!image.src" color="primary">{{$translate('Save')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
function getMimeType(file, fallback = null) {
    const byteArray = (new Uint8Array(file)).subarray(0, 4);
    let header = '';
    for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16);
    }
    switch (header) {
        case "89504e47":
            return "image/png";
        case "47494638":
            return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            return "image/jpeg";
        default:
            return fallback;
    }
}

import { Cropper, Preview } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import UserAvatar from './UserAvatar.vue';
export default {
    name: 'zoezi-image-uploader',

    components: {
        Cropper,
        UserAvatar,
        Preview
    },

    props: ['value', 'user'],

    watch: {
        show: {
            immediate: true,
            handler(show) {
                if (!show) {
                    URL.revokeObjectURL(this.image.src);
                    this.image.src = null;
                    this.image.type = null;
                }
                this.$emit('input', show);
            }
        },
        value: {
            immediate: true,
            handler(value) {
                this.show = value;
            }
        }
    },

    data: () => ({
        saving: false,
        show: false,
        image: {
            src: null,
            type: null
        },
        result: {
            coordinates: null,
            image: null
        }
    }),
    methods: {
        change({ coordinates, image }) {
            this.result = {
                coordinates,
                image
            };
        },
        save() {
            this.saving = true;
            const { canvas } = this.$refs.cropper.getResult();
            if (canvas) {
                const form = new FormData();
                canvas.toBlob(blob => {
                    form.append('file', blob);
                    this.$api.post('/api/memberapi/image/set', form, {user_id: this.user.id}).then((response) => {
                        this.saving = false;
                        if (response.ok) {
                            this.show = false;
                        } else {
                            this.$store.commit('showSnackBar', {text: 'Det gick inte att spara'});
                        }
                    })
                }, this.image.type);
            }
        },
        fileSelected(event) {
            const { files } = event.target;
            // Ensure that you have a file before attempting to read it
            if (files && files[0]) {
                // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
                if (this.image.src) {
                    URL.revokeObjectURL(this.image.src)
                }
                // 2. Create the blob link to the file to optimize performance:
                const blob = URL.createObjectURL(files[0]);

                // 3. The steps below are designated to determine a file mime type to use it during the
                // getting of a cropped image from the canvas. You can replace it them by the following string,
                // but the type will be derived from the extension and it can lead to an incorrect result:
                //
                // this.image = {
                //    src: blob;
                //    type: files[0].type
                // }

                // Create a new FileReader to read this image binary data
                const reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.image" refers to the image of Vue component
                    this.image = {
                        // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
                        src: blob,
                        // Determine the image type to preserve it during the extracting the image from canvas:
                        type: getMimeType(e.target.result, files[0].type),
                    };
                };
                // Start the reader job - read file as a data url (base64 format)
                reader.readAsArrayBuffer(files[0]);
            }
        }
    },
}
</script>
